import * as BABYLON from "babylonjs";
import "babylonjs-materials";
import gsap from "gsap";

import { setState } from "store/game";
import store from "store";
import EventPubSub from "scripts/util/EventPubSub";
import qs from "query-string";

import AssetLoader from "../loaders/AssetLoader";
import RootObjects from "../game/RootObjects";
import Sled from "../game/Sled";
import Track from "../game/Track";
import Snow from "../game/Snow";
import VFX from "../../util/VFX";
import LevelManager from "../game/LevelManager";
import Snowmen from "../game/Snowmen";
import Snowman from "../game/Snowman";
import splatFrames from "../../../components/UiEffects/Splat/frames";
// import AudioManager from "scripts/util/AudioManager";
// import * as GUI from "babylonjs-gui";

const query = qs.parse(window.location.search);
const LEVEL_DIR = `${process.env.PUBLIC_URL}/3D/levels`;
const HDRI_DIR = `${process.env.PUBLIC_URL}/3D/hdri`;
const MODELS_DIR = `${process.env.PUBLIC_URL}/3D/models`;
const TEXTURES_DIR = `${process.env.PUBLIC_URL}/3D/textures`;
const UI_EFFECTS_DIR = `${process.env.PUBLIC_URL}/UI/effects`;
// const BASE_TIME = parseInt(query.base_time) || 60;
const BASE_TIME = parseInt(query.base_time) || 90;
const TIME_BONUS = 15;
// const FRAME_RATE = 60

class MainExperience {
  init(canvas) {
    this.canvas = canvas;
    this.engine = new BABYLON.Engine(canvas, true);

    this.reset();
    this.character = "seal";

    window.addEventListener("resize", () => {
      this.engine.resize();
    });

    this.scene = new BABYLON.Scene(this.engine);
    this.scene.autoClear = false; // Color buffer
    this.scene.autoClearDepthAndStencil = false; // Depth and stencil, obviously
    this.scene.useGeometryIdsMap = true;
    this.scene.useMaterialMeshMap = true;

    // DEBUG POINTER PICK TESTER!!!!
    // this.scene.onPointerObservable.add((pointerInfo) => {
    //   if (pointerInfo.type === BABYLON.PointerEventTypes.POINTERDOWN) {
    //     if(pointerInfo.pickInfo.pickedMesh)
    //     console.log(pointerInfo.pickInfo.pickedMesh.name);
    //   }
    // });

    this.runForever = false;
    if (window.location.search.includes("forever")) this.runForever = true;

    // const gl = new BABYLON.GlowLayer("glow", this.scene, {
    //   // mainTextureFixedSize: 1024,
    //   blurKernelSize: 128,
    //   // mainTextureSamples: 4,
    // })

    // gl.intensity = 1
    // const gl = new BABYLON.BloomEffect(
    //   this.scene,
    //   400,
    //   30,
    //   30
    // ) /* eslint-disable-line */

    this.remoteHandler = (payload) => {
      if (!this.running) {
        return;
      }
      if (payload === "up") {
        this.sled.jump();
      }
      if (payload === "left") {
        this.sled.changeLane(-1);
      }
      if (payload === "right") {
        this.sled.changeLane(1);
      }
      if (payload === "action") {
        if (this.paused === false) {
          this.pause();
        }
      }
    };

    EventPubSub.subscribe("remote", this.remoteHandler);
    EventPubSub.subscribe("pause", this.pause.bind(this));
    EventPubSub.subscribe("resume", this.resume.bind(this));
  }

  setupSnowmen() {
    console.log("SETUP SNOWMEN");
  }

  loadClones() {
    this.snowmenContainers = [];
    this.snowmen = [];
    return new Promise((resolve) => {
      BABYLON.SceneLoader.LoadAssetContainer(
        `${MODELS_DIR}/`,
        "Snowman.glb",
        this.scene,
        function (container) {
          const NUM_OF_SNOWMEN = 6;
          for (let i = 0; i < NUM_OF_SNOWMEN; i++) {
            const s = container.instantiateModelsToScene();
            console.log("SNOWMAN:", s);
            this.snowmenContainers.push(s);
            const sman = new Snowman(s, i);
            this.snowmen.push(sman);
          }
          console.log("SNOWMEN CLONED");
          Snowmen.init(this.snowmen, NUM_OF_SNOWMEN);
          resolve();
        }.bind(this)
      );
    });
  }
  load(character) {
    this.characterType = character;

    const MAP = {
      seal: `${MODELS_DIR}/Seal/Seal.gltf`,
      yeti: `${MODELS_DIR}/Yeti/Yeti.gltf`,
      bear: `${MODELS_DIR}/Bear/Bear.gltf`,
    };

    return new Promise((resolve) => {
      AssetLoader.load(
        {
          models: {
            Character: MAP[this.characterType],
            Presents: `${MODELS_DIR}/Presents.glb`,
            Watch: `${MODELS_DIR}/watch.glb`,
            Headphones: `${MODELS_DIR}/headphones.glb`,
            Phone: `${MODELS_DIR}/phone.glb`,
            Boost: `${MODELS_DIR}/Boost.glb`,
            TrackLoop: `${MODELS_DIR}/Track_loop.glb`,
            // trackGreen: `${MODELS_DIR}/trackGreen.glb`,
            // trackRed: `${MODELS_DIR}/trackRed.glb`,
            Cave: `${MODELS_DIR}/cave.glb`,
            CaveEntrance: `${MODELS_DIR}/entrance.glb`,
            Icewalls: `${MODELS_DIR}/IceWalls.glb`,
            IcewallsCave: `${MODELS_DIR}/IceWallsCave.glb`,
            Drifts: `${MODELS_DIR}/Drifts.glb`,
            DriftsCave: `${MODELS_DIR}/DriftsCave.glb`,
            Rocks: `${MODELS_DIR}/Rocks.glb`,
            Geodes: `${MODELS_DIR}/Geodes.glb`,
            Trees: `${MODELS_DIR}/Trees.glb`,
            Stalagmites: `${MODELS_DIR}/Stalagmites.glb`,
            ExtraTime: `${MODELS_DIR}/Extra_Time.glb`,
            Store: `${MODELS_DIR}/Store.glb`,
            // SkyDome: `${MODELS_DIR}/SkyDome.glb`,
            // SkyDome: `${MODELS_DIR}/dome2.glb`,
            SkyDome: `${MODELS_DIR}/skyPlane.glb`,
            // Snowmen: `${MODELS_DIR}/Snowman.glb`,
            IcePatch: `${MODELS_DIR}/Ice-Patch.glb`,
            // Mounds: `${MODELS_DIR}/Mound.glb`,
            Star: `${MODELS_DIR}/Star.glb`,
          },
          textures: {
            Snow: `${TEXTURES_DIR}/snow.png`,
            SnowFlakes: `${TEXTURES_DIR}/snowflakes2.png`,
            Flare: `${TEXTURES_DIR}/Flare.png`,
            Spark: `${TEXTURES_DIR}/spark.png`,
            Smoke: `${TEXTURES_DIR}/Smoke.png`,
            Snowflake: `${TEXTURES_DIR}/snowflake.png`,
            Star: `${TEXTURES_DIR}/star.png`,
            Rays: `${TEXTURES_DIR}/rays.png`,
            Burst: `${TEXTURES_DIR}/burst.png`,
            SledCloud: `${TEXTURES_DIR}/sledCloud.png`,
            SledSpatter: `${TEXTURES_DIR}/sledSpatter.png`,
            SledFake: `${TEXTURES_DIR}/sledFake.png`,
            // Sky: `${TEXTURES_DIR}/skynew.jpg`,
            // Pebbles1: `${TEXTURES_DIR}/pebbles1.png`,
            // Pebbles2: `${TEXTURES_DIR}/pebbles2.png`,
            PresentSparks: `${TEXTURES_DIR}/presentSparks.png`,
            PowerSprites1: `${TEXTURES_DIR}/p1.png`,
            PowerSprites2: `${TEXTURES_DIR}/p2.png`,
            PowerSprites3: `${TEXTURES_DIR}/p3.png`,
            LightingCave: `${TEXTURES_DIR}/lightingCave.png`,
            LightingCaveEntrance: `${TEXTURES_DIR}/lightingCaveEntrance.png`,
            SnowmanHatScarfLightmap: `${TEXTURES_DIR}/Snowman_Hat_Scarf_Lightmap.png`,
            SnowmanMeshLightmap: `${TEXTURES_DIR}/Snowman_Mesh_Lightmap.png`,
          },
          images: {
            ...splatFrames,
          },
          environments: {
            //hdri: `${HDRI_DIR}/regular.env`,
            // hdri: `${HDRI_DIR}/blue.env`,
            hdri: `${HDRI_DIR}/blue4k.env`,
          },
          containers: {
            Snowball: `${MODELS_DIR}/Snowball.glb`,
          },
          data: {
            start: `${LEVEL_DIR}/start.json`,
            one: `${LEVEL_DIR}/one.json`,
            two: `${LEVEL_DIR}/two.json`,
            three: `${LEVEL_DIR}/three.json`,
            four: `${LEVEL_DIR}/four.json`,
            five: `${LEVEL_DIR}/five.json`,
            fourcave: `${LEVEL_DIR}/fourcave.json`,
            fivecave: `${LEVEL_DIR}/fivecave.json`,
            six: `${LEVEL_DIR}/six.json`,
            shortcut: `${LEVEL_DIR}/shortcut.json`,
            end: `${LEVEL_DIR}/end.json`,
            blank: `${LEVEL_DIR}/blank.json`,
            test: `${LEVEL_DIR}/test.json`,
            testcave: `${LEVEL_DIR}/testcave.json`,
          },
        },
        this.scene
      ).then(resolve);
    });
  }

  initExperience() {
    this.createScene();
    this.initLights();
    this.initCamera();
    this.initPostProcess();
    // this.modifyMaterials();
    // this.skyShader3();
    // this.freezeMaterials();
    this.start();
  }

  // modifyMaterials() { //---- BAD PERF - may be able to choose singles
  //   this.scene.meshes.forEach(function (m) {
  //     if (m.material) m.material.realTimeFiltering = true; // waay too slow
  //   });
  // }

  freezeMaterials() {
    this.scene.meshes.forEach(function (m) {
      if (m.material) m.material.freeze();
    });
  }

  initPostProcess() {
    const colorPostProcess = new BABYLON.ColorCorrectionPostProcess(
      "color_correction",
      // "3D/textures/lut-default.png",
      "3D/textures/lut4.png",
      1.0,
      this.camera
    );

    var postProcess = new BABYLON.ImageProcessingPostProcess(
      "processing",
      1.0,
      this.camera
    );
    postProcess.vignetteWeight = 0;
    postProcess.vignetteStretch = 1;
    postProcess.vignetteColor = new BABYLON.Color4(0, 0, 0, 0);
    postProcess.vignetteEnabled = false;
    this.track.setPost(postProcess);
    this.track.setSnow(this.snow);

    const gl = new BABYLON.GlowLayer("glow", this.scene, {
      mainTextureSamples: 4,
    });

    const meshNamesToGlow = ["Present", "5G", "Extra_Time"]; //,"Boost"];
    gl.customEmissiveColorSelector = function (
      mesh,
      subMesh,
      material,
      result
    ) {
      if (meshNamesToGlow.some((meshName) => mesh.name.includes(meshName))) {
        result.set(1, 1, 1, 0.15);
      } else {
        result.set(0, 0, 0, 0);
      }
    };
  }

  start() {
    RootObjects.init({
      sled: this.sled,
      scene: this.scene,
      track: this.track,
      camera: this.camera,
    });

    this.engine.runRenderLoop(() => {
      this.update();
      this.scene.render();
      // this.checkFPS()
    });
    this.canvas.focus();
    setTimeout(() => {
      this.sled.intro();
      setTimeout(() => {
        this.running = true;
        if (window.location.search.includes("paused")) this.running = false;
        gsap.to(this.camera, { duration: 0.3, radius: 5 });
        this.snow.changeSpeed(1);
      }, 2000);
    }, 3000);

    LevelManager.addCallback(() => {
      this.track.updatePoints(Math.round(this.time * 15));
      store.dispatch(setState({ winner: true }));
      this.gameOver();
    });
  }

  checkFPS() {
    const fpsLabel = document.getElementById("fpsLabel");
    if (fpsLabel) {
      fpsLabel.innerHTML = this.engine.getFps().toFixed() + " fps";
    }
  }

  initCamera() {
    let camera;
    console.log("SLEDTARGET", this.sled.target);
    if (window.location.search.includes("dev")) {
      camera = new BABYLON.ArcRotateCamera(
        "ArcRotateCamera",
        Math.PI / 2,
        Math.PI / 2.2,
        10,
        new BABYLON.Vector3(0, 0, 0),
        this.scene
      );
      camera.attachControl(this.canvas, true);
    } else {
      camera = new BABYLON.FollowCamera(
        "FollowCamera",
        new BABYLON.Vector3(0, 2, 0),
        this.scene,
        this.sled.target
      );
      camera.fov = 0.9;
      camera.cameraAcceleration = 0.05;
      camera.heightOffset = 1;
      camera.radius = 4;
    }

    camera.inputs.remove(camera.inputs.attached.keyboard);
    this.camera = camera;
  }

  initLights() {
    const cameraTransform = new BABYLON.TransformNode(
      "cameraTransform",
      this.scene
    );
    cameraTransform.rotationQuaternion = null;
    cameraTransform.rotation = new BABYLON.Vector3(0, 0, 0);

    const spotlight = new BABYLON.SpotLight(
      "spotLight",
      new BABYLON.Vector3(0, 8.2, 3.4),
      new BABYLON.Vector3(0, -1, -0.7),
      Math.PI, //cone angle
      10, //speed of decay
      this.scene
    );
    const colorBright = 1; //.5; //0-1
    spotlight.diffuse = new BABYLON.Color3(
      colorBright,
      colorBright * 0.9,
      colorBright * 0.66
    );
    spotlight.intensity = 500;
    spotlight.shadowEnabled = false;
    spotlight.name = "CHARACTERSPOT";
    // spotlight.projectionTexture = AssetLoader.getTexture("Star");
    // spotlight.setDirectionToTarget(BABYLON.Vector3.Zero());
    spotlight.parent = this.sledAsParent;
    this.spotlight = spotlight;

    let hdriTexture = AssetLoader.getEnvironment("hdri");
    hdriTexture.gammaSpace = false;
    this.scene.environmentTexture = hdriTexture;

    //REGULAR
    this.scene.environmentIntensity = 0.9; //.44; //1.33

    //BLUE
    this.scene.environmentIntensity = 6.8; //.44; //1.33

    //BLUE4K
    this.scene.environmentIntensity = 1.8; //1.59

    var hdrRotation = 162; // in degrees - REGULAR
    hdrRotation = 169; //BLUE
    hdrRotation = 136; //BLUE4K
    hdriTexture.setReflectionTextureMatrix(
      BABYLON.Matrix.RotationY(BABYLON.Tools.ToRadians(hdrRotation))
    );
    this.hdriTexture = hdriTexture;

    //CHARACTER UNDERLIGHT

    var hemilight = new BABYLON.HemisphericLight(
      "HEMILIGHT",
      new BABYLON.Vector3(0, -1, 0),
      this.scene
    );
    hemilight.intensity = 1.245;
    hemilight.diffuse = new BABYLON.Color3(0.639, 0.917, 0.98);
    hemilight.specular = new BABYLON.Color3(0, 0, 0);
    hemilight.groundColor = new BABYLON.Color3(0.464, 0.464, 0.464);
    hemilight.includedOnlyMeshes.push(this.characterMesh);
    hemilight.falloffType = 3;
    this.hemilight = hemilight;

    this.scene.imageProcessingConfiguration.toneMappingEnabled = true;
    this.scene.imageProcessingConfiguration.toneMappingType =
      BABYLON.ImageProcessingConfiguration.TONEMAPPING_ACES;

    // //REGULAR
    // this.scene.imageProcessingConfiguration.contrast = 2.3;
    // this.scene.imageProcessingConfiguration.exposure = 0.9;

    // //BLUE
    // this.scene.imageProcessingConfiguration.contrast = 1.9;
    // this.scene.imageProcessingConfiguration.exposure = 1.0;

    //BLUE4K
    this.scene.imageProcessingConfiguration.contrast = 1.6;
    this.scene.imageProcessingConfiguration.exposure = 0.9;
  }

  createScene() {
    //clean up anything that needs instanced
    const instanceRoots = [
      "Store",
      "Trees",
      "Rocks",
      "ExtraTime",
      "Drifts",
      "Icewalls",
      "Boost",
      "Presents",
      "IcePatch",
      "Star",
      // "Snowmen",
    ];
    instanceRoots.forEach((key) => {
      const meshes = AssetLoader.getModel(key).meshes;
      meshes.forEach((mesh, index) => {
        mesh.isVisible = false;
      });
    });

    AssetLoader.getModel("Character").meshes.forEach((mesh) => {
      mesh.isPickable = false;
      if (
        mesh.name === "SK_Yeti" ||
        mesh.name === "SK_Seal" ||
        mesh.name === "Bear"
      )
        this.characterMesh = mesh;

      if (mesh.name.includes("_primitive")) {
        mesh.material.specularIntensity = 0;
      }
      if (mesh.name.includes("Sled")) {
        mesh.material.specularIntensity = 0.2;
        console.log("SLED", mesh);
        this.sledAsParent = mesh;
      }
    });
    this.VFX = new VFX(this.scene);
    this.sled = new Sled(
      AssetLoader.getModel("Character"),
      this.characterType,
      this.scene,
      this.VFX
    );

    this.track = new Track(
      AssetLoader.getModel("TrackLoop").meshes[0],
      AssetLoader.getModel("Cave").meshes[0],
      AssetLoader.getModel("CaveEntrance").meshes[1],
      this.trackEventHandler.bind(this),
      this.VFX,
      // AssetLoader.getModel("trackRed").meshes[0],
      // AssetLoader.getModel("trackGreen").meshes[0],
    );
    this.snow = new Snow(this.scene);

    if (window.location.search.includes("debug")) {
      this.scene.debugLayer.show();
    }

    //flat aurora
    // const flatsky = BABYLON.MeshBuilder.CreatePlane("flatsky", {
    //   height: 70,
    //   width: 400,
    // });
    // flatsky.rotation.y = Math.PI;
    // flatsky.position.z = -307;
    // flatsky.position.y += 0; //60
    // this.flatsky = flatsky;
    //this.flatsky.isVisible=false;

    //fix skydome material
    // let sky = AssetLoader.getModel("SkyDome").meshes[1];
    // sky.position.y = sky.position.y + 140;
    // this.sky = sky;
  }

  trackEventHandler(event) {
    if (event === "Time") {
      this.time += TIME_BONUS;
    }
  }

  pause() {
    this.running = false;
    this.paused = true;
    if (this.snow) {
      this.snow.pause();
    }
  }

  resume() {
    setTimeout(() => {
      this.paused = false;
      this.running = true;
      if (this.snow) {
        this.snow.resume();
      }
    }, 500);
  }

  reset() {
    this.elapsedTime = 0;
    this.time = BASE_TIME;
    this.points = 0;
    this.aDelta = 0;
    this.paused = false;
    this.ended = false;
  }

  win() {
    if (this.ended) {
      return;
    }
    store.dispatch(setState({ winner: true }));
    this.gameOver();
  }

  lose() {
    if (this.ended) {
      return;
    }
    store.dispatch(setState({ winner: false }));
    this.gameOver();
  }

  gameOver() {
    this.running = false;
    this.ended = true;
    this.track.stop();
    this.VFX.stopSledSnow();
    EventPubSub.emit("game", "gameover");
  }

  runFixedUpdates() {
    this.sled.update();
    this.track.update();
    this.track.checkCollisions(this.sled.collider);
    if (this.sled.isSnowball) {
      this.track.checkCollisions(this.sled.goodCollider);
    }

    if (this.time <= 0 && !this.runForever) {
      store.dispatch(setState({ winner: false }));
      this.gameOver();
    }

    const timeIncrement = (1 / 60) * this.scene.getAnimationRatio();

    const newTime = Math.round(this.time - timeIncrement);
    const currentTime = Math.round(this.time);
    if (newTime !== currentTime) {
      this.track.boostTick();
      store.dispatch(setState({ time: newTime }));
    }

    this.time -= timeIncrement;
    this.elapsedTime += timeIncrement;
    this.aDelta -= timeIncrement;
  }

  update() {
    if (this.running) {
      this.runFixedUpdates();
    }
    // if (this.waterMat) {
    //   this.waterMat.setFloat("iTime", this.waterTime);
    //   this.waterTime += 0.05;
    // }
  }
}

export default new MainExperience();
